module.exports = __webpack_public_path__ + "img/place-6-z7.a2d2d51b.svg";